export default __webpack_public_path__ + "static/assets/717d56e35e7b8b12d87b9640463f79f4.svg";